import { Component, OnInit, ElementRef, AfterViewInit } from "@angular/core";
import { SystemService } from "../app/service/system.service";
import { ModalService } from "./service/modal-service";
import { TimeoutService } from "./service/timeout.service";
import { ActivatedRoute, Params, Route, Router, RouterEvent } from "@angular/router";
import { UserSessionPingService } from "./service/user-session-ping.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
export class AppComponent implements OnInit, AfterViewInit {
  title = "e-ISuite";
  username: string;
  dbname: string;
  currentAriaPage = "";
  currentAriaPageSubscription;
  sub: Subscription;

  constructor(
    public systemService: SystemService,
    private modalService: ModalService,
    public timeoutService: TimeoutService,
    public userSessionPingService: UserSessionPingService,
    private router: Router,
    private route: ActivatedRoute,
    private el: ElementRef
  ) {
  }
  resetActivedb() {
    this.username = this.dbname = "";
  }
  ngOnInit() {
    this.systemService.setCurrentAriaPage(
      this.systemService.runModeDisplay + " " + "Warning Page"
    );
    this.currentAriaPage =
      this.systemService.runModeDisplay + " " + "Warning Page";

    // this.dbname = localStorage.getItem('database');
    this.systemService.currentdbname.subscribe(
      (dbname) => (this.dbname = dbname)
    );
    this.systemService.currentUsername.subscribe((username) => {
      this.username = username;
      if (this.username) {
        this.timeoutService.initInterval();
        this.userSessionPingService.initInterval();
      }
    });
    this.showToaster();
    /*
    this.currentAriaPageSubscription = this.systemService.currentAriaPage.subscribe(v => {
      this.currentAriaPage =  v;
      document.getElementById('pageHdr').focus();
    });
  */
  }

  ngAfterViewInit() {
    //    document.getElementById('appMainHdr').nodeValue = 'Page';
    //    this.el.nativeElement.innerHTML = '<h1 class="hidden">' + 'page' + '</h1>';
  }

  showToaster() {
    // this.notifyService.showSuccess('Data shown successfully !!', 'Notification');
  }

  continueWorking() {
    this.timeoutService.reset();
    this.modalService.close("session-timeout-warning");
  }

  logout() {
    this.modalService.close("session-timeout-logout");
    this.router.navigate([""]);
  }

  userDisconnected() {
    this.modalService.close("user-disconnected");
    this.router.navigate([""]);
  }

  openHelp() {
    this.systemService.getHelpUrl().subscribe((data) => {
      if (data["courseOfActionVo"]["coaName"] === "GET_HELP_URL") {
        const helpUrl = String(data["resultObject"]);
        // console.log(helpUrl);
        window.open(helpUrl, "_blank");
      }
    });
  }
}
